/**
 * Catalogue des habilitations CBConnect - MIROIR EXACT de la table `habilitation`.
 *
 * Le backend n'autorise plus sur le nom du profil (`hasRole('SE')`) mais sur
 * l'habilitation (`hasAuthority('SINISTRE_ASSIGN')`). Un administrateur peut donc
 * créer autant de profils qu'il veut : ils obtiennent leurs droits par les
 * habilitations qu'on leur coche, sans qu'une ligne de code change.
 *
 * Règle côté front : une garde d'UI s'écrit `can(HAB.X)` - jamais `profil === 'CSS'`.
 *
 * ⚠ Fichier GÉNÉRÉ depuis les @PreAuthorize du backend. Pour ajouter un droit :
 *    1. créer l'habilitation par migration Flyway,
 *    2. poser @PreAuthorize("hasAuthority('MON_CODE')") sur l'endpoint,
 *    3. ajouter la constante ici.
 */

export const HAB = {
  // ── ADMIN
  ADMIN_RECONCILIATION: 'ADMIN_RECONCILIATION',
  // ── AFFECTATION
  AFFECTATION_EXPERT_CREATE: 'AFFECTATION_EXPERT_CREATE',
  AFFECTATION_EXPERT_UPDATE: 'AFFECTATION_EXPERT_UPDATE',
  // ── APP_MOBILE (distribution de l'application mobile)
  APP_MOBILE_PUBLIER: 'APP_MOBILE_PUBLIER',
  APP_MOBILE_TELECHARGER: 'APP_MOBILE_TELECHARGER',
  // ── ASSURE
  ASSURE_CREATE: 'ASSURE_CREATE',
  ASSURE_DELETE: 'ASSURE_DELETE',
  ASSURE_UPDATE: 'ASSURE_UPDATE',
  // ── ATTESTATION
  ATTESTATION_ANNULER: 'ATTESTATION_ANNULER',
  ATTESTATION_CREATE: 'ATTESTATION_CREATE',
  ATTESTATION_FACTURER: 'ATTESTATION_FACTURER',
  // ── AUDIT
  AUDIT_HISTORIQUE_READ: 'AUDIT_HISTORIQUE_READ',
  JOURNAL_ACTIVITE_READ: 'JOURNAL_ACTIVITE_READ',
  // ── BANQUE
  BANQUE_CREATE: 'BANQUE_CREATE',
  BANQUE_DELETE: 'BANQUE_DELETE',
  BANQUE_UPDATE: 'BANQUE_UPDATE',
  // ── BAREMES
  BAREMES_CREATE: 'BAREMES_CREATE',
  BAREMES_DELETE: 'BAREMES_DELETE',
  BAREMES_UPDATE: 'BAREMES_UPDATE',
  // ── BILATERAL
  BILATERAL_DEMO_CREATE: 'BILATERAL_DEMO_CREATE',
  // ── BORDEREAU
  BORDEREAU_CREATE: 'BORDEREAU_CREATE',
  BORDEREAU_READ: 'BORDEREAU_READ',
  BORDEREAU_DELETE: 'BORDEREAU_DELETE',
  BORDEREAU_RETOURNER: 'BORDEREAU_RETOURNER',
  BORDEREAU_UPDATE: 'BORDEREAU_UPDATE',
  // ── COMPTABILITE
  COMPTABILITE_READ: 'COMPTABILITE_READ',
  // Tenir le plan comptable, les journaux et les schémas d'écriture. Distincte
  // d'ECRITURE_VALIDER : valider porte sur une opération passée, paramétrer
  // engage toutes les écritures à venir.
  PARAM_COMPTABLE_UPDATE: 'PARAM_COMPTABLE_UPDATE',
  // ── COURRIER
  COURRIER_CREATE: 'COURRIER_CREATE',
  COURRIER_DELETE: 'COURRIER_DELETE',
  COURRIER_READ: 'COURRIER_READ',
  COURRIER_READ_BANNETTE: 'COURRIER_READ_BANNETTE',
  // ── GED / REGISTRE (lecture) - requis par les pages-hub Courriers et GED
  GED_READ: 'GED_READ',
  REGISTRE_READ: 'REGISTRE_READ',
  COURRIER_TRAITER: 'COURRIER_TRAITER',
  // ── DELAI
  DELAI_INITIALISER: 'DELAI_INITIALISER',
  DELAI_PARAMETRER: 'DELAI_PARAMETRER',
  DELAI_PENALITES_READ: 'DELAI_PENALITES_READ',
  DELAI_READ: 'DELAI_READ',
  DELAI_RECALCULER: 'DELAI_RECALCULER',
  DELAI_RELANCER: 'DELAI_RELANCER',
  DELAI_RESOUDRE: 'DELAI_RESOUDRE',
  // ── DISCUSSION (collaboration interne entre agents)
  DISCUSSION_READ: 'DISCUSSION_READ',
  DISCUSSION_CREATE: 'DISCUSSION_CREATE',
  DISCUSSION_MODERATE: 'DISCUSSION_MODERATE',
  // ── DOSSIER
  DOSSIER_BILATERAL_DECISION: 'DOSSIER_BILATERAL_DECISION',
  DOSSIER_BILATERAL_DELETE: 'DOSSIER_BILATERAL_DELETE',
  DOSSIER_BILATERAL_UPDATE: 'DOSSIER_BILATERAL_UPDATE',
  // ── ECRITURE
  ECRITURE_VALIDER: 'ECRITURE_VALIDER',
  // ── ENCAISSEMENT
  ENCAISSEMENT_ANNULER: 'ENCAISSEMENT_ANNULER',
  ENCAISSEMENT_CREATE: 'ENCAISSEMENT_CREATE',
  ENCAISSEMENT_ENCAISSER: 'ENCAISSEMENT_ENCAISSER',
  // ── ENTITE
  ENTITE_CONSTAT_CREATE: 'ENTITE_CONSTAT_CREATE',
  ENTITE_CONSTAT_DELETE: 'ENTITE_CONSTAT_DELETE',
  ENTITE_CONSTAT_UPDATE: 'ENTITE_CONSTAT_UPDATE',
  // ── EXPERT
  EXPERT_CREATE: 'EXPERT_CREATE',
  EXPERT_READ: 'EXPERT_READ',
  EXPERT_DELETE: 'EXPERT_DELETE',
  EXPERT_UPDATE: 'EXPERT_UPDATE',
  // ── EXPERTISE
  EXPERTISE_MATERIELLE_CREATE: 'EXPERTISE_MATERIELLE_CREATE',
  EXPERTISE_MATERIELLE_UPDATE: 'EXPERTISE_MATERIELLE_UPDATE',
  EXPERTISE_MEDICALE_CREATE: 'EXPERTISE_MEDICALE_CREATE',
  EXPERTISE_MEDICALE_DELETE: 'EXPERTISE_MEDICALE_DELETE',
  EXPERTISE_MEDICALE_READ: 'EXPERTISE_MEDICALE_READ',
  EXPERTISE_MEDICALE_UPDATE: 'EXPERTISE_MEDICALE_UPDATE',
  // ── FACTURE
  FACTURE_RECLAMATION_CREATE: 'FACTURE_RECLAMATION_CREATE',
  FACTURE_RECLAMATION_DELETE: 'FACTURE_RECLAMATION_DELETE',
  FACTURE_RECLAMATION_UPDATE: 'FACTURE_RECLAMATION_UPDATE',
  // ── GED
  GED_CREATE: 'GED_CREATE',
  GED_DOSSIER_VICTIME_CREATE: 'GED_DOSSIER_VICTIME_CREATE',
  GED_DOWNLOAD: 'GED_DOWNLOAD',
  GED_MAINTENANCE: 'GED_MAINTENANCE',
  // ── HABILITATION
  HABILITATION_CREATE: 'HABILITATION_CREATE',
  HABILITATION_DELETE: 'HABILITATION_DELETE',
  HABILITATION_READ: 'HABILITATION_READ',
  HABILITATION_UPDATE: 'HABILITATION_UPDATE',
  // ── INDEMNISATION
  INDEMNISATION_CREATE: 'INDEMNISATION_CREATE',
  INDEMNISATION_DELETE: 'INDEMNISATION_DELETE',
  INDEMNISATION_UPDATE: 'INDEMNISATION_UPDATE',
  INDEMNISATION_VALIDER: 'INDEMNISATION_VALIDER',
  // ── LOT
  LOT_REGLEMENT_COMPTABILISER: 'LOT_REGLEMENT_COMPTABILISER',
  LOT_REGLEMENT_CREATE: 'LOT_REGLEMENT_CREATE',
  LOT_REGLEMENT_READ: 'LOT_REGLEMENT_READ',
  // ── ORGANISME
  ORGANISME_CREATE: 'ORGANISME_CREATE',
  ORGANISME_DELETE: 'ORGANISME_DELETE',
  ORGANISME_UPDATE: 'ORGANISME_UPDATE',
  // ── PAIEMENT
  PAIEMENT_ANNULER: 'PAIEMENT_ANNULER',
  PAIEMENT_COMPTABILISER: 'PAIEMENT_COMPTABILISER',
  PAIEMENT_CREATE: 'PAIEMENT_CREATE',
  PAIEMENT_IMPUTATION_DELETE: 'PAIEMENT_IMPUTATION_DELETE',
  PAIEMENT_READ: 'PAIEMENT_READ',
  // ── PARAMETRE
  PARAMETRE_CREATE: 'PARAMETRE_CREATE',
  PARAMETRE_DELETE: 'PARAMETRE_DELETE',
  PARAMETRE_UPDATE: 'PARAMETRE_UPDATE',

  // ── SIGNATURE
  // Deposer sa signature et decider de l'apposer sur un document sont deux gestes
  // differents : un agent peut avoir une signature enregistree sans avoir a choisir,
  // document par document, s'il la pose.
  SIGNATURE_DEPOSER: 'SIGNATURE_DEPOSER',
  SIGNATURE_PARAMETRER: 'SIGNATURE_PARAMETRER',
  SIGNATURE_APPOSER: 'SIGNATURE_APPOSER',
  // ── PAYS
  PAYS_CREATE: 'PAYS_CREATE',
  PAYS_DELETE: 'PAYS_DELETE',
  PAYS_UPDATE: 'PAYS_UPDATE',
  // ── PERFORMANCE
  PERFORMANCE_READ: 'PERFORMANCE_READ',
  // ── PREFINANCEMENT
  PREFINANCEMENT_CREATE: 'PREFINANCEMENT_CREATE',
  PREFINANCEMENT_READ: 'PREFINANCEMENT_READ',
  PREFINANCEMENT_TRAITER: 'PREFINANCEMENT_TRAITER',
  // ── PROFIL
  PROFIL_CREATE: 'PROFIL_CREATE',
  PROFIL_DELETE: 'PROFIL_DELETE',
  PROFIL_UPDATE: 'PROFIL_UPDATE',
  // ── PV
  PV_ASSOCIER: 'PV_ASSOCIER',
  PV_CREATE: 'PV_CREATE',
  PV_DELETE: 'PV_DELETE',
  PV_READ: 'PV_READ',
  PV_UPDATE: 'PV_UPDATE',
  // ── RECLAMATION
  RECLAMATION_CREATE: 'RECLAMATION_CREATE',
  RECLAMATION_UPDATE: 'RECLAMATION_UPDATE',
  // ── REGISTRE
  REGISTRE_CLOTURER: 'REGISTRE_CLOTURER',
  REGISTRE_CREATE: 'REGISTRE_CREATE',
  REGISTRE_VISER: 'REGISTRE_VISER',
  // ── RELANCE
  RELANCE_BILATERALE_UPDATE: 'RELANCE_BILATERALE_UPDATE',
  // ── RENCONTRE
  RENCONTRE_BILATERALE_CREATE: 'RENCONTRE_BILATERALE_CREATE',
  RENCONTRE_BILATERALE_DELETE: 'RENCONTRE_BILATERALE_DELETE',
  RENCONTRE_BILATERALE_UPDATE: 'RENCONTRE_BILATERALE_UPDATE',
  // ── SESSION
  SESSION_COMPAGNIE_CREATE: 'SESSION_COMPAGNIE_CREATE',
  SESSION_COMPAGNIE_UPDATE: 'SESSION_COMPAGNIE_UPDATE',
  // ── SINISTRE
  SINISTRE_ASSIGN: 'SINISTRE_ASSIGN',
  // Se servir dans la corbeille des declarations (migration V47). Distincte de
  // SINISTRE_ASSIGN, qui permet d'affecter un dossier a AUTRUI : un redacteur doit
  // pouvoir prendre un dossier libre sans pouvoir en distribuer aux autres.
  SINISTRE_AUTO_AFFECTATION: 'SINISTRE_AUTO_AFFECTATION',
  SINISTRE_CLOTURER: 'SINISTRE_CLOTURER',
  SINISTRE_CREATE: 'SINISTRE_CREATE',
  SINISTRE_REOUVRIR: 'SINISTRE_REOUVRIR',
  SINISTRE_DELETE: 'SINISTRE_DELETE',
  SINISTRE_ENCAISSEMENT_READ: 'SINISTRE_ENCAISSEMENT_READ',
  SINISTRE_GARANTIE: 'SINISTRE_GARANTIE',
  // Lier/detacher des dossiers au sein d'une liaison SL-YYYY-XXXX (migration
  // V202609150002). Distincte de SINISTRE_UPDATE : ne modifie ni statut, ni
  // date, ni montant d'un dossier.
  SINISTRE_LIER: 'SINISTRE_LIER',
  SINISTRE_LITIGE: 'SINISTRE_LITIGE',
  SINISTRE_UPDATE: 'SINISTRE_UPDATE',
  // Valider OU classer sans suite une declaration mobile (statut SOUMISE). Distincte
  // de SINISTRE_UPDATE : elle fait entrer un dossier partiel dans le workflow, ce que
  // tout agent habilite a modifier un dossier ne doit pas pouvoir faire.
  SINISTRE_VALIDER_DECLARATION: 'SINISTRE_VALIDER_DECLARATION',
  // ── MOBILE (canal usager - migration V202608050002)
  // Lire la file ne suffit pas a agir dessus : MOBILE_DECLARATION_READ est accorde
  // au REDACTEUR, qui consulte, alors que SINISTRE_VALIDER_DECLARATION ne l'est
  // qu'a ADMIN / SE / CSS. Garder les deux distinctes dans les gardes d'UI.
  MOBILE_DECLARATION_READ: 'MOBILE_DECLARATION_READ',
  MOBILE_MESSAGE_CREATE: 'MOBILE_MESSAGE_CREATE',
  MOBILE_MESSAGE_READ: 'MOBILE_MESSAGE_READ',
  MOBILE_RATTACHEMENT_CONFIRMER: 'MOBILE_RATTACHEMENT_CONFIRMER',
  MOBILE_RATTACHEMENT_READ: 'MOBILE_RATTACHEMENT_READ',
  MOBILE_USAGER_READ: 'MOBILE_USAGER_READ',
  MOBILE_USAGER_VERIFIER_IDENTITE: 'MOBILE_USAGER_VERIFIER_IDENTITE',
  // ── OFFRE (publication vers l'application)
  OFFRE_PUBLIER_MOBILE: 'OFFRE_PUBLIER_MOBILE',
  // ── UTILISATEUR
  UTILISATEUR_CREATE: 'UTILISATEUR_CREATE',
  UTILISATEUR_DELETE: 'UTILISATEUR_DELETE',
  UTILISATEUR_READ: 'UTILISATEUR_READ',
  UTILISATEUR_UPDATE: 'UTILISATEUR_UPDATE',
  // ── VICTIME
  VICTIME_CREATE: 'VICTIME_CREATE',
  VICTIME_DELETE: 'VICTIME_DELETE',
  VICTIME_POSITION_RC: 'VICTIME_POSITION_RC',
  VICTIME_UPDATE: 'VICTIME_UPDATE',
};

/* ── REPLI TRANSITOIRE ────────────────────────────────────────────────────────
 * Utilisé UNIQUEMENT si `user.habilitations` est absent - c'est-à-dire pour une
 * session ouverte avant le déploiement du backend qui expose les habilitations
 * au login. Reproduit à l'identique la matrice de la migration
 * V202607130001__rbac_habilitations_socle.sql.
 *
 * À SUPPRIMER une fois tous les postes reconnectés (aucune session pré-bascule).
 * ------------------------------------------------------------------------- */
export const HAB_PAR_PROFIL_LEGACY = {
  /* SUPERADMIN manquait a cette table, et son absence ne se voyait pas : le repli
     rendait alors une liste VIDE, donc AUCUN droit d'ecran, pour le compte qui en a
     le plus. C'est ce qui s'est produit des qu'une reponse serveur sans
     habilitations a ecrase la session. Il herite du jeu de l'ADMIN : en base il en
     detient un sur-ensemble, et ce repli ne sert qu'aux sessions ouvertes avant la
     bascule RBAC - la source de verite reste le serveur. */
  get SUPERADMIN() { return this.ADMIN; },
  ADMIN: [
    HAB.ADMIN_RECONCILIATION,
    HAB.AUDIT_HISTORIQUE_READ,
    HAB.BANQUE_CREATE,
    HAB.BANQUE_DELETE,
    HAB.BANQUE_UPDATE,
    HAB.BAREMES_CREATE,
    HAB.BAREMES_DELETE,
    HAB.BAREMES_UPDATE,
    HAB.DELAI_PARAMETRER,
    HAB.DELAI_RECALCULER,
    HAB.ENTITE_CONSTAT_CREATE,
    HAB.ENTITE_CONSTAT_DELETE,
    HAB.ENTITE_CONSTAT_UPDATE,
    HAB.EXPERT_CREATE,
    HAB.EXPERT_DELETE,
    HAB.EXPERT_UPDATE,
    HAB.GED_DOWNLOAD,
    HAB.HABILITATION_CREATE,
    HAB.HABILITATION_DELETE,
    HAB.HABILITATION_READ,
    HAB.HABILITATION_UPDATE,
    HAB.ORGANISME_CREATE,
    HAB.ORGANISME_DELETE,
    HAB.ORGANISME_UPDATE,
    HAB.PARAMETRE_CREATE,
    HAB.PARAMETRE_DELETE,
    HAB.PARAMETRE_UPDATE,
    HAB.PAYS_CREATE,
    HAB.PAYS_DELETE,
    HAB.PAYS_UPDATE,
    HAB.PERFORMANCE_READ,
    HAB.PROFIL_CREATE,
    HAB.PROFIL_DELETE,
    HAB.PROFIL_UPDATE,
    HAB.SINISTRE_CLOTURER,
    HAB.SINISTRE_REOUVRIR,
    HAB.UTILISATEUR_CREATE,
    HAB.UTILISATEUR_DELETE,
    HAB.UTILISATEUR_READ,
    HAB.UTILISATEUR_UPDATE,
  ],
  COMPTABLE: [
    HAB.ADMIN_RECONCILIATION,
    HAB.ATTESTATION_CREATE,
    HAB.ATTESTATION_FACTURER,
    HAB.COMPTABILITE_READ,
    HAB.DELAI_PENALITES_READ,
    HAB.ECRITURE_VALIDER,
    HAB.ENCAISSEMENT_CREATE,
    HAB.ENCAISSEMENT_ENCAISSER,
    HAB.LOT_REGLEMENT_COMPTABILISER,
    HAB.LOT_REGLEMENT_READ,
    HAB.PAIEMENT_ANNULER,
    HAB.PAIEMENT_COMPTABILISER,
    HAB.PAIEMENT_IMPUTATION_DELETE,
    HAB.PAIEMENT_READ,
    HAB.PREFINANCEMENT_READ,
    HAB.PREFINANCEMENT_TRAITER,
    HAB.SINISTRE_ENCAISSEMENT_READ,
  ],
  COURSIER: [
    HAB.BORDEREAU_CREATE,
    HAB.BORDEREAU_UPDATE,
  ],
  CSS: [
    HAB.AFFECTATION_EXPERT_CREATE,
    HAB.AFFECTATION_EXPERT_UPDATE,
    HAB.ASSURE_CREATE,
    HAB.ASSURE_UPDATE,
    HAB.ATTESTATION_CREATE,
    HAB.BORDEREAU_CREATE,
    HAB.BORDEREAU_DELETE,
    HAB.BORDEREAU_RETOURNER,
    HAB.BORDEREAU_UPDATE,
    HAB.COURRIER_CREATE,
    HAB.COURRIER_DELETE,
    HAB.COURRIER_READ,
    HAB.COURRIER_READ_BANNETTE,
    HAB.COURRIER_TRAITER,
    HAB.DELAI_INITIALISER,
    HAB.DELAI_PENALITES_READ,
    HAB.DELAI_READ,
    HAB.DELAI_RELANCER,
    HAB.DELAI_RESOUDRE,
    HAB.DOSSIER_BILATERAL_DECISION,
    HAB.DOSSIER_BILATERAL_DELETE,
    HAB.DOSSIER_BILATERAL_UPDATE,
    HAB.EXPERTISE_MATERIELLE_CREATE,
    HAB.EXPERTISE_MATERIELLE_UPDATE,
    HAB.EXPERTISE_MEDICALE_CREATE,
    HAB.EXPERTISE_MEDICALE_DELETE,
    HAB.EXPERTISE_MEDICALE_READ,
    HAB.EXPERTISE_MEDICALE_UPDATE,
    HAB.EXPERT_CREATE,
    HAB.FACTURE_RECLAMATION_CREATE,
    HAB.FACTURE_RECLAMATION_DELETE,
    HAB.FACTURE_RECLAMATION_UPDATE,
    HAB.GED_CREATE,
    HAB.GED_DOSSIER_VICTIME_CREATE,
    HAB.GED_DOWNLOAD,
    HAB.GED_MAINTENANCE,
    HAB.INDEMNISATION_CREATE,
    HAB.INDEMNISATION_DELETE,
    HAB.INDEMNISATION_UPDATE,
    HAB.INDEMNISATION_VALIDER,
    HAB.LOT_REGLEMENT_READ,
    HAB.PAIEMENT_READ,
    HAB.PERFORMANCE_READ,
    HAB.PREFINANCEMENT_READ,
    HAB.PV_ASSOCIER,
    HAB.PV_CREATE,
    HAB.PV_DELETE,
    HAB.PV_READ,
    HAB.PV_UPDATE,
    HAB.RECLAMATION_CREATE,
    HAB.RECLAMATION_UPDATE,
    HAB.REGISTRE_CLOTURER,
    HAB.REGISTRE_CREATE,
    HAB.REGISTRE_VISER,
    HAB.RELANCE_BILATERALE_UPDATE,
    HAB.RENCONTRE_BILATERALE_CREATE,
    HAB.RENCONTRE_BILATERALE_DELETE,
    HAB.RENCONTRE_BILATERALE_UPDATE,
    HAB.SESSION_COMPAGNIE_CREATE,
    HAB.SESSION_COMPAGNIE_UPDATE,
    HAB.SINISTRE_AUTO_AFFECTATION,
    HAB.SINISTRE_ASSIGN,
    HAB.SINISTRE_CLOTURER,
    HAB.SINISTRE_CREATE,
    HAB.SINISTRE_ENCAISSEMENT_READ,
    HAB.SINISTRE_GARANTIE,
    HAB.SINISTRE_LITIGE,
    HAB.SINISTRE_REOUVRIR,
    HAB.SINISTRE_UPDATE,
    HAB.UTILISATEUR_READ,
    HAB.VICTIME_CREATE,
    HAB.VICTIME_DELETE,
    HAB.VICTIME_POSITION_RC,
    HAB.VICTIME_UPDATE,
  ],
  GESTIONNAIRE: [
    HAB.GED_DOWNLOAD,
    HAB.SINISTRE_ASSIGN,
    HAB.SINISTRE_GARANTIE,
    HAB.VICTIME_POSITION_RC,
  ],
  REDACTEUR: [
    HAB.AFFECTATION_EXPERT_CREATE,
    HAB.AFFECTATION_EXPERT_UPDATE,
    HAB.ASSURE_CREATE,
    HAB.ASSURE_UPDATE,
    HAB.ATTESTATION_CREATE,
    HAB.ATTESTATION_FACTURER,
    HAB.COURRIER_CREATE,
    HAB.COURRIER_READ,
    HAB.COURRIER_TRAITER,
    HAB.DELAI_RELANCER,
    HAB.DELAI_RESOUDRE,
    HAB.DOSSIER_BILATERAL_UPDATE,
    HAB.EXPERTISE_MATERIELLE_CREATE,
    HAB.EXPERTISE_MATERIELLE_UPDATE,
    HAB.EXPERTISE_MEDICALE_CREATE,
    HAB.EXPERTISE_MEDICALE_READ,
    HAB.EXPERTISE_MEDICALE_UPDATE,
    HAB.FACTURE_RECLAMATION_CREATE,
    HAB.FACTURE_RECLAMATION_DELETE,
    HAB.FACTURE_RECLAMATION_UPDATE,
    HAB.GED_CREATE,
    HAB.GED_DOSSIER_VICTIME_CREATE,
    HAB.GED_DOWNLOAD,
    HAB.INDEMNISATION_CREATE,
    HAB.INDEMNISATION_DELETE,
    HAB.INDEMNISATION_UPDATE,
    HAB.LOT_REGLEMENT_CREATE,
    HAB.LOT_REGLEMENT_READ,
    HAB.PAIEMENT_ANNULER,
    HAB.PAIEMENT_CREATE,
    HAB.PAIEMENT_READ,
    HAB.PREFINANCEMENT_CREATE,
    HAB.PREFINANCEMENT_READ,
    HAB.PREFINANCEMENT_TRAITER,
    HAB.PV_ASSOCIER,
    HAB.PV_CREATE,
    HAB.RECLAMATION_CREATE,
    HAB.RELANCE_BILATERALE_UPDATE,
    HAB.SINISTRE_AUTO_AFFECTATION,
    HAB.SINISTRE_CREATE,
    HAB.SINISTRE_ENCAISSEMENT_READ,
    HAB.SINISTRE_GARANTIE,
    HAB.SINISTRE_UPDATE,
    HAB.VICTIME_CREATE,
    HAB.VICTIME_POSITION_RC,
    HAB.VICTIME_UPDATE,
  ],
  SE: [
    HAB.AFFECTATION_EXPERT_CREATE,
    HAB.AFFECTATION_EXPERT_UPDATE,
    HAB.ASSURE_CREATE,
    HAB.ASSURE_DELETE,
    HAB.ASSURE_UPDATE,
    HAB.ATTESTATION_ANNULER,
    HAB.ATTESTATION_CREATE,
    HAB.ATTESTATION_FACTURER,
    HAB.BANQUE_CREATE,
    HAB.BANQUE_DELETE,
    HAB.BANQUE_UPDATE,
    HAB.BILATERAL_DEMO_CREATE,
    HAB.BORDEREAU_CREATE,
    HAB.BORDEREAU_DELETE,
    HAB.BORDEREAU_RETOURNER,
    HAB.BORDEREAU_UPDATE,
    HAB.COMPTABILITE_READ,
    HAB.COURRIER_CREATE,
    HAB.COURRIER_DELETE,
    HAB.COURRIER_READ,
    HAB.COURRIER_READ_BANNETTE,
    HAB.COURRIER_TRAITER,
    HAB.DELAI_INITIALISER,
    HAB.DELAI_PENALITES_READ,
    HAB.DELAI_READ,
    HAB.DELAI_RECALCULER,
    HAB.DELAI_RELANCER,
    HAB.DELAI_RESOUDRE,
    HAB.DOSSIER_BILATERAL_DECISION,
    HAB.DOSSIER_BILATERAL_DELETE,
    HAB.DOSSIER_BILATERAL_UPDATE,
    HAB.ECRITURE_VALIDER,
    HAB.ENCAISSEMENT_ANNULER,
    HAB.ENCAISSEMENT_CREATE,
    HAB.ENCAISSEMENT_ENCAISSER,
    HAB.ENTITE_CONSTAT_CREATE,
    HAB.ENTITE_CONSTAT_DELETE,
    HAB.ENTITE_CONSTAT_UPDATE,
    HAB.EXPERTISE_MATERIELLE_CREATE,
    HAB.EXPERTISE_MATERIELLE_UPDATE,
    HAB.EXPERTISE_MEDICALE_CREATE,
    HAB.EXPERTISE_MEDICALE_DELETE,
    HAB.EXPERTISE_MEDICALE_READ,
    HAB.EXPERTISE_MEDICALE_UPDATE,
    HAB.EXPERT_CREATE,
    HAB.EXPERT_DELETE,
    HAB.EXPERT_UPDATE,
    HAB.FACTURE_RECLAMATION_CREATE,
    HAB.FACTURE_RECLAMATION_DELETE,
    HAB.FACTURE_RECLAMATION_UPDATE,
    HAB.GED_CREATE,
    HAB.GED_DOSSIER_VICTIME_CREATE,
    HAB.GED_DOWNLOAD,
    HAB.GED_MAINTENANCE,
    HAB.HABILITATION_CREATE,
    HAB.HABILITATION_DELETE,
    HAB.HABILITATION_READ,
    HAB.HABILITATION_UPDATE,
    HAB.INDEMNISATION_CREATE,
    HAB.INDEMNISATION_DELETE,
    HAB.INDEMNISATION_UPDATE,
    HAB.INDEMNISATION_VALIDER,
    HAB.LOT_REGLEMENT_COMPTABILISER,
    HAB.LOT_REGLEMENT_CREATE,
    HAB.LOT_REGLEMENT_READ,
    HAB.ORGANISME_CREATE,
    HAB.ORGANISME_DELETE,
    HAB.ORGANISME_UPDATE,
    HAB.PAIEMENT_ANNULER,
    HAB.PAIEMENT_COMPTABILISER,
    HAB.PAIEMENT_CREATE,
    HAB.PAIEMENT_READ,
    HAB.PARAMETRE_CREATE,
    HAB.PARAMETRE_DELETE,
    HAB.PARAMETRE_UPDATE,
    HAB.PERFORMANCE_READ,
    HAB.PREFINANCEMENT_CREATE,
    HAB.PREFINANCEMENT_READ,
    HAB.PREFINANCEMENT_TRAITER,
    HAB.PROFIL_CREATE,
    HAB.PROFIL_DELETE,
    HAB.PROFIL_UPDATE,
    HAB.PV_ASSOCIER,
    HAB.PV_CREATE,
    HAB.PV_DELETE,
    HAB.PV_READ,
    HAB.PV_UPDATE,
    HAB.RECLAMATION_CREATE,
    HAB.RECLAMATION_UPDATE,
    HAB.REGISTRE_CLOTURER,
    HAB.REGISTRE_CREATE,
    HAB.REGISTRE_VISER,
    HAB.RELANCE_BILATERALE_UPDATE,
    HAB.RENCONTRE_BILATERALE_CREATE,
    HAB.RENCONTRE_BILATERALE_DELETE,
    HAB.RENCONTRE_BILATERALE_UPDATE,
    HAB.SESSION_COMPAGNIE_CREATE,
    HAB.SESSION_COMPAGNIE_UPDATE,
    HAB.SINISTRE_AUTO_AFFECTATION,
    HAB.SINISTRE_ASSIGN,
    HAB.SINISTRE_CLOTURER,
    HAB.SINISTRE_CREATE,
    HAB.SINISTRE_DELETE,
    HAB.SINISTRE_ENCAISSEMENT_READ,
    HAB.SINISTRE_GARANTIE,
    HAB.SINISTRE_LITIGE,
    HAB.SINISTRE_REOUVRIR,
    HAB.SINISTRE_UPDATE,
    HAB.UTILISATEUR_CREATE,
    HAB.UTILISATEUR_DELETE,
    HAB.UTILISATEUR_READ,
    HAB.UTILISATEUR_UPDATE,
    HAB.VICTIME_CREATE,
    HAB.VICTIME_DELETE,
    HAB.VICTIME_POSITION_RC,
    HAB.VICTIME_UPDATE,
  ],
  SECRETAIRE: [
    HAB.ASSURE_CREATE,
    HAB.BORDEREAU_CREATE,
    HAB.BORDEREAU_UPDATE,
    HAB.COURRIER_CREATE,
    HAB.COURRIER_READ,
    HAB.COURRIER_READ_BANNETTE,
    HAB.COURRIER_TRAITER,
    HAB.FACTURE_RECLAMATION_CREATE,
    HAB.GED_CREATE,
    HAB.PV_ASSOCIER,
    HAB.PV_CREATE,
    HAB.PV_READ,
    HAB.PV_UPDATE,
    HAB.REGISTRE_CLOTURER,
    HAB.REGISTRE_CREATE,
    HAB.SINISTRE_CREATE,
  ],
};
